export default __webpack_public_path__ + "static/media/logo-white.5f81f9df.png";